module.exports = __webpack_public_path__ + "img/next-arrow-cool.3fc7bf83.svg";